import { AddCustomTicketRequest } from './add.custom.ticket.request';

export class EditCustomTicketRequest extends AddCustomTicketRequest {

    TicketID: number;

}
